import React from 'react';

import {
  TileFragmentFragment,
  TileFragmentNoGridFragment,
} from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';
import { parseComponents } from '@/ui/utils/tiles';
import { CONTENT_WRAPPER_SHAPE_ID } from '@/utils/experiment-helper';
import { useOrderReference } from '@/ui/providers/order-reference-provider';
import { getJobs } from '@/server-functions/jobs';
import CustomerSupportForm from '@/ui/components/tiles/CustomerSupportForm';
import { loadCSForm, loadCSFormOptions } from '@/server-functions/csForm/loadCSForm';
import DoubleOptIn from '@/ui/components/tiles/DoubleOptIn/double-opt-in';
import { DoubleOptInTileType } from '@/ui/components/tiles/DoubleOptIn/types/double-opt-in-tile-type';
import CsChannelHandover from '@/ui/components/tiles/CsChannelHandover';
import { CsChannelHandoverTile } from '@/ui/components/tiles/CsChannelHandover/types/CsChannelHandoverTile';
import FilloutEmbed, { FilloutEmbedTile } from '@/ui/components/tiles/fillout-embed/fillout-embed';
import { VideoSlider } from '@/ui/components/tiles/video-slider/video-slider';
import { VideoSliderTile } from '@/ui/components/tiles/video-slider/video-slider-types';
import { VideoText5050 } from '@/ui/components/tiles/video-text-5050/video-text-5050';
import { VideoText5050Tile } from '@/ui/components/tiles/video-text-5050/video-text-5050-types';
import { VideoHero } from '@/ui/components/tiles/video-hero/video-hero';
import { VideoHeroTile } from '@/ui/components/tiles/video-hero/video-hero-types';
import ImageWithContent from '../../tiles/ImageWithContent';
import Video from '../../tiles/Video/video';
import Logobar from '../../tiles/Logobar';
import NewsletterSignup from '../../tiles/NewsletterSignup';
import FaqContainer, { FaqContainerTile } from '../../tiles/faq-container/faq-container';
import ImageText5050 from '../../tiles/ImageText5050';
import MulticolumnLayout from '../../tiles/MulticolumnLayout';
import ThreeColumnSlider from '../../tiles/ThreeColumnSlider';
import DynamicComparisonTable from '../../tiles/DynamicComparisonTable/dynamic-comparison-table';
import OneColumnSlider from '../../tiles/OneColumnSlider';
import AccordionTabSwitcher, {
  AccordionTabSwitcherTile,
} from '../../tiles/accordion-tab-switcher/accordion-tab-switcher';
import StaticComparisonTable from '../../tiles/StaticComparisonTable';
import ProductCards from '../../tiles/product-cards/product-cards';
import Breadcrumbs from '../../tiles/Breadcrumbs';
import ThreeColumnSliderV2 from '../../tiles/ThreeColumnSliderV2';
import BlogRichtext from '../../tiles/BlogRichtext';
import ProductOneColumnSlider from '../../tiles/ProductOneColumnSlider';
import { ImageWithContentTile } from '../../tiles/ImageWithContent/types/ImageWithContentTile';
import { VideoTile } from '../../tiles/Video/types/VideoTile';
import { LogobarTile } from '../../tiles/Logobar/types/LogobarTile';
import { NewsletterSignupTile } from '../../tiles/NewsletterSignup/types/NewsletterSignupTile';
import { ThreeColumnSliderTile } from '../../tiles/ThreeColumnSlider/types/ThreeColumnSliderTile';
import { ThreeColumnSliderV2Tile } from '../../tiles/ThreeColumnSliderV2/types/ThreeColumnSliderV2Tile';
import { ImageText5050Tile } from '../../tiles/ImageText5050/types/ImageText5050Tile';
import { BreadcrumbsTile } from '../../tiles/Breadcrumbs/types/BreadcrumbsTile';
import { MulticolumnLayoutTile } from '../../tiles/MulticolumnLayout/types/MulticolumnLayoutTile';
import { DynamicComparisonTableTile } from '../../tiles/DynamicComparisonTable/types/DynamicComparisonTableTile';
import { StaticComparisonTableTile } from '../../tiles/StaticComparisonTable/types/StaticComparisonTableTile';
import { OneColumnSliderTile } from '../../tiles/OneColumnSlider/types/OneColumnSliderTile';
import { ProductCardsTile } from '../../tiles/product-cards/types/product-cards-tile';
import { BlogRichtextTile } from '../../tiles/BlogRichtext/types/BlogRichtextTile';
import { ProductOneColumnSliderTile } from '../../tiles/ProductOneColumnSlider/types/ProductOneColumnSliderTile';
import ShsPricing from '../../tiles/ShsPricing';
import Spacer from '../../tiles/Spacer';
import StandaloneCta from '../../tiles/StandaloneCta';
import { ShsPricingTile } from '../../tiles/ShsPricing/types/ShsPricingTile';
import { SpacerTile } from '../../tiles/Spacer/types/SpacerTile';
import { StandaloneCtaTile } from '../../tiles/StandaloneCta/types/StandaloneCtaTile';
import { AnchorTile } from '../../tiles/Anchor/types/Anchor';
import Anchor from '../../tiles/Anchor';
import TextBlockContainer from '../../tiles/TextBlockContainer';
import { TextBlockContainerTile } from '../../tiles/TextBlockContainer/types/TextBlockContainerTile';
import Bento from '../../tiles/Bento';
import { BentoTile } from '../../tiles/Bento/types/BentoTile';
import CustomHtml from '../../tiles/CustomHtml';
import { CustomHtmlTile } from '../../tiles/CustomHtml/types/CustomHtmlTile';
import { TrustpilotWidget } from '../../tiles/trustpilot-widget/trustpilot-widget';
import { TrustpilotWidgetTile } from '../../tiles/trustpilot-widget/types/trustpilot-widget-tile';
import { TrustpilotEmbed } from '../../tiles/trustpilot-embed/trustpilot-embed';
import * as TrustpilotEmbedHelper from '../../tiles/trustpilot-embed/trustpilot-embed-helper';
import ContactElement from '../../tiles/ContactElement';
import { ContactElementTile } from '../../tiles/ContactElement/types/ContactElementTile';
import OpenerCompatibilityCheck from '../../tiles/OpenerCompatibilityCheck';
import { OpenerCompatibilityCheckTile } from '../../tiles/OpenerCompatibilityCheck/types/OpenerCompatibilityCheck';
import FileLinkList from '../../tiles/FIleLinkList';
import { FileLinkListTile } from '../../tiles/FIleLinkList/types/FIleLinkListTile';
import ClubRegistration from '../../tiles/ClubRegistration';
import { ClubRegistrationTile } from '../../tiles/ClubRegistration/types/ClubRegistrationTile';
import B2BContactForm from '../../tiles/B2BContactForm';
import { B2BContactFormTile } from '../../tiles/B2BContactForm/types/B2BContactFormTile';
import TechnicalData from '../../tiles/TechnicalData';
import { TechnicalDataTile } from '../../tiles/TechnicalData/types/TechnicalDataTile';
import BentoNew from '../../tiles/BentoNew';
import { BentoNewTile } from '../../tiles/BentoNew/types/BentoNewTile';
import GenericContactForm from '../../tiles/GenericContactForm';
import { GenericContactFormTile } from '../../tiles/GenericContactForm/types/GenericContactFormTile';
import JobList from '../../tiles/JobListTile/JobListTile';
import NukiPremiumActivationFormTile from '../../tiles/NukiPremiumActivationFormTile/NukiPremiumActivationFormTile';
import { NukiPremiumReferAFriendForm } from '../../tiles/NukiPremiumReferFriendForm/refer-friend-form';
import {
  RmaFreeTrialForm,
  RmaFreeTrialFormTile,
} from '../../tiles/rma-free-trial-form/rma-free-trial-form';
import {
  BetaProgramForm,
  BetaProgramFormTile,
} from '../../tiles/beta-program-form/beta-program-form';
import {
  RmaTrialThankYou,
  RmaTrialThankYouTile,
} from '../../tiles/rma-trial-thank-you/rma-trial-thank-you';
import { StarRating, StarRatingTile } from '../../tiles/star-rating/star-rating';
import { WithdrawalRequestFormTile } from '../../tiles/withdrawal/withdrawal-request-form-tile/withdrawal-request-form-tile';
import { WithdrawalRequestFormTileType } from '../../tiles/withdrawal/withdrawal-request-form-tile/types/withdrawal-request-form-tile-type';
import { WithdrawalConfirmTile } from '../../tiles/withdrawal/withdrawal-confirm-tile/withdrawal-confirm-tile';
import { WithdrawalConfirmTileType } from '../../tiles/withdrawal/withdrawal-confirm-tile/types/withdrawal-confirm-tile-type';
import { WithdrawalSuccessTile } from '../../tiles/withdrawal/withdrawal-success-tile/withdrawal-success-tile';
import { WithdrawalSuccessTileType } from '../../tiles/withdrawal/withdrawal-success-tile/types/withdrawal-success-tile-type';
import {
  ClassicProductDetail,
  ClassicProductDetailTile,
} from '../../tiles/classic-product-detail/classic-product-detail';
import {
  OrderConfirmationPaymentStatus,
  OrderConfirmationPaymentStatusTile,
} from '../../tiles/order-confirmation-payment-status/order-confirmation-payment-status';
import { ConfirmationPageOrderSummary } from '../../tiles/order-summary/order-summary';
import { DeliveryInfo } from '../../tiles/delivery-info/delivery-info';
import { DeliveryTracking } from '../../tiles/delivery-tracking/delivery-tracking';
// `split-layout` is a container tile: it renders tiles (TilesArrayRenderer -> TileRenderer), so this
// tile <-> renderer recursion is a deliberate import cycle. It is safe: the components are only
// referenced at render time, never at module init. See the matching disables in tiles-array-renderer
// and split-layout.
// eslint-disable-next-line import/no-cycle
import { SplitLayout, SplitLayoutTile } from '../../tiles/split-layout/split-layout';

export default function TileRenderer({
  tile,
  trackingPrefix,
}: Readonly<{
  tile: TileFragmentFragment | TileFragmentNoGridFragment;
  trackingPrefix?: string;
}>) {
  const shape = tile.shape.identifier;
  const parsedComponents = parseComponents(tile.components);
  // On the order-confirmation page tiles are stacked, so the star-rating tile takes a divider there.
  const isOnOrderPage = useOrderReference() !== undefined;

  // Setting the type of parsedComponents here because we've already checked the shape
  // and we know what the parsedComponents will be
  switch (shape) {
    case 'image-with-content':
      return (
        <ImageWithContent
          tile={parsedComponents as ImageWithContentTile}
          trackingPrefix={trackingPrefix}
        />
      );
    case 'video':
      return <Video tile={parsedComponents as VideoTile} trackingPrefix={trackingPrefix} />;
    case 'video-slider':
      return (
        <VideoSlider tile={parsedComponents as VideoSliderTile} trackingPrefix={trackingPrefix} />
      );
    case 'video-text-5050':
      return (
        <VideoText5050
          tile={parsedComponents as VideoText5050Tile}
          trackingPrefix={trackingPrefix}
        />
      );
    case 'video-hero':
      return <VideoHero tile={parsedComponents as VideoHeroTile} trackingPrefix={trackingPrefix} />;
    case 'logobar':
      return <Logobar tile={parsedComponents as LogobarTile} />;
    case 'newsletter-signup':
      return (
        <NewsletterSignup
          tile={parsedComponents as NewsletterSignupTile}
          trackingPrefix={trackingPrefix}
        />
      );
    case 'three-column-slider':
      return (
        <ThreeColumnSlider
          tile={parsedComponents as ThreeColumnSliderTile}
          trackingPrefix={trackingPrefix}
        />
      );
    case 'three-column-slider-v2':
      return (
        <ThreeColumnSliderV2
          tile={parsedComponents as ThreeColumnSliderV2Tile}
          trackingPrefix={trackingPrefix}
        />
      );
    case 'faq-container':
      return (
        <FaqContainer tile={parsedComponents as FaqContainerTile} trackingPrefix={trackingPrefix} />
      );
    case 'image-text-5050':
      return (
        <ImageText5050
          tile={parsedComponents as ImageText5050Tile}
          trackingPrefix={trackingPrefix}
        />
      );
    case 'breadcrumbs':
      return (
        <Breadcrumbs tile={parsedComponents as BreadcrumbsTile} trackingPrefix={trackingPrefix} />
      );
    case 'multicolumn-layout':
      return <MulticolumnLayout tile={parsedComponents as MulticolumnLayoutTile} />;
    case 'dynamic-comparison-table': {
      return (
        <DynamicComparisonTable
          tile={parsedComponents as DynamicComparisonTableTile}
          trackingPrefix={trackingPrefix}
        />
      );
    }
    case 'static-comparison-table': {
      return (
        <StaticComparisonTable
          tile={parsedComponents as StaticComparisonTableTile}
          trackingPrefix={trackingPrefix}
        />
      );
    }
    case 'one-column-slider':
      return <OneColumnSlider tile={parsedComponents as OneColumnSliderTile} />;
    case 'product-cards': {
      return (
        <ProductCards tile={parsedComponents as ProductCardsTile} trackingPrefix={trackingPrefix} />
      );
    }
    case 'accordion-tab-switcher':
      return (
        <AccordionTabSwitcher
          tile={parsedComponents as AccordionTabSwitcherTile}
          trackingPrefix={trackingPrefix}
        />
      );
    case 'blog-richtext':
      return <BlogRichtext tile={parsedComponents as BlogRichtextTile} />;
    case 'product-one-column-slider':
      return (
        <ProductOneColumnSlider
          tile={parsedComponents as ProductOneColumnSliderTile}
          trackingPrefix={trackingPrefix}
        />
      );
    case 'shs-pricing-tile':
      return (
        <ShsPricing tile={parsedComponents as ShsPricingTile} trackingPrefix={trackingPrefix} />
      );
    case 'spacer':
      return <Spacer tile={parsedComponents as SpacerTile} />;
    case 'standalone-cta':
      return (
        <StandaloneCta
          tile={parsedComponents as StandaloneCtaTile}
          trackingPrefix={trackingPrefix}
        />
      );
    case 'anchor':
      return <Anchor tile={parsedComponents as AnchorTile} />;
    case 'textblock-container':
      return (
        <TextBlockContainer
          tile={parsedComponents as TextBlockContainerTile}
          trackingPrefix={trackingPrefix}
        />
      );
    case 'bento':
      return <Bento tile={parsedComponents as BentoTile} trackingPrefix={trackingPrefix} />;
    case 'custom-html': {
      // Trustpilot embeds are rendered via TrustpilotEmbed (React-safe imperative mount) so
      // Trustpilot's injected iframe isn't removed on hydration/re-render; other HTML stays
      // on the generic CustomHtml tile.
      const customHtml = (parsedComponents as CustomHtmlTile).html?.text ?? '';
      if (TrustpilotEmbedHelper.isTrustpilotWidgetHtml(customHtml)) {
        return <TrustpilotEmbed html={customHtml} />;
      }
      return <CustomHtml tile={parsedComponents as CustomHtmlTile} />;
    }
    case 'trustpilot-widget': {
      const trustpilotTile = parsedComponents as TrustpilotWidgetTile;
      return <TrustpilotWidget height={trustpilotTile.height?.text ?? undefined} />;
    }
    case 'contact-element':
      return (
        <ContactElement
          tile={parsedComponents as ContactElementTile}
          trackingPrefix={trackingPrefix}
        />
      );
    case 'opener-compatibility-check':
      return (
        <OpenerCompatibilityCheck
          tile={parsedComponents as OpenerCompatibilityCheckTile}
          trackingPrefix={trackingPrefix}
        />
      );
    case 'file-link-list':
      return <FileLinkList tile={parsedComponents as FileLinkListTile} />;
    case 'club-registration':
      return (
        <ClubRegistration
          tile={parsedComponents as ClubRegistrationTile}
          trackingPrefix={trackingPrefix}
        />
      );
    case 'doubleoptin':
      return (
        <DoubleOptIn
          tile={parsedComponents as DoubleOptInTileType}
          trackingPrefix={trackingPrefix}
        />
      );
    case 'b2b-contact-form':
      return (
        <B2BContactForm
          tile={parsedComponents as B2BContactFormTile}
          trackingPrefix={trackingPrefix}
        />
      );
    case 'technical-data':
      return <TechnicalData tile={parsedComponents as TechnicalDataTile} />;
    case 'bento-new':
      return <BentoNew tile={parsedComponents as BentoNewTile} trackingPrefix={trackingPrefix} />;
    case 'generic-contact-form':
      return (
        <GenericContactForm
          tile={parsedComponents as GenericContactFormTile}
          trackingPrefix={trackingPrefix}
        />
      );
    case 'job-list':
      return (
        <JobList tile={parsedComponents} fetchJobs={getJobs} trackingPrefix={trackingPrefix} />
      );
    case 'nuki-premium-activation-code-form':
      return <NukiPremiumActivationFormTile trackingPrefix={trackingPrefix} />;
    case 'nuki-premium-refer-a-friend-form':
      return <NukiPremiumReferAFriendForm trackingPrefix={trackingPrefix} />;
    case 'rma-free-trial-form':
      return (
        <RmaFreeTrialForm
          tile={parsedComponents as RmaFreeTrialFormTile}
          trackingPrefix={trackingPrefix}
        />
      );
    case 'rma-trial-thank-you':
      return <RmaTrialThankYou tile={parsedComponents as RmaTrialThankYouTile} />;
    case 'beta-program-form':
      return (
        <BetaProgramForm
          tile={parsedComponents as BetaProgramFormTile}
          trackingPrefix={trackingPrefix}
        />
      );
    case 'star-rating':
      return (
        <StarRating
          tile={parsedComponents as StarRatingTile}
          trackingPrefix={trackingPrefix}
          hasBorderTop={isOnOrderPage}
        />
      );
    case 'classic-product-detail':
      return <ClassicProductDetail tile={parsedComponents as ClassicProductDetailTile} />;
    case 'cs-form-tile':
      return (
        <CustomerSupportForm
          tile={parsedComponents}
          loadCSForm={loadCSForm}
          loadCSFormOptions={loadCSFormOptions}
          trackingPrefix={trackingPrefix}
        />
      );
    case 'fillout-embed':
      return <FilloutEmbed tile={parsedComponents as FilloutEmbedTile} />;
    case 'cs-channel-handover':
      return (
        <CsChannelHandover
          tile={parsedComponents as CsChannelHandoverTile}
          trackingPrefix={trackingPrefix}
        />
      );
    case 'withdrawal-request-form':
      return (
        <WithdrawalRequestFormTile
          tile={parsedComponents as WithdrawalRequestFormTileType}
          trackingPrefix={trackingPrefix}
        />
      );
    case 'withdrawal-confirm':
      return (
        <WithdrawalConfirmTile
          tile={parsedComponents as WithdrawalConfirmTileType}
          trackingPrefix={trackingPrefix}
        />
      );
    case 'withdrawal-success':
      return <WithdrawalSuccessTile tile={parsedComponents as WithdrawalSuccessTileType} />;
    case CONTENT_WRAPPER_SHAPE_ID:
      // A content wrapper is never rendered directly: TilesArrayRenderer replaces it with the
      // candidates of the chosen experiment arm. Reaching here means a wrapper slipped past that
      // resolution, so render nothing rather than the "not implemented" placeholder.
      return null;
    case 'order-confirmation-payment-status':
      return (
        <OrderConfirmationPaymentStatus
          tile={parsedComponents as OrderConfirmationPaymentStatusTile}
        />
      );
    case 'order-summary':
      return <ConfirmationPageOrderSummary />;
    case 'delivery-info':
      return <DeliveryInfo />;
    case 'delivery-tracking':
      return <DeliveryTracking />;
    case 'split-layout':
      return <SplitLayout tile={parsedComponents as SplitLayoutTile} />;
    default:
      return <p>Tile shape not implemented</p>;
  }
}
